import type { DomainMapper } from '../types';

const base = {
  countryCode: 'at',
  currency: 'EUR',
  environment: 'production',
  flagUrl: '/flags/AT.svg',
  languagePrimary: false,
  locale: 'de',
  logoUrl: 'kahrs-logo',
  noRobots: false,
  productBasePath: 'produkt',
  sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-at.xml',
  storyblokBasePath: 'at',
  algoliaIndex: 'b2c-at-de-DE-products',
  algoliaIndexAutocomplete: 'b2c-at-de-DE-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1636,
  subFolder: true,
  googleSiteVerification: 'tHG4C4vnMgMxfElDcGevBx5-SKSflV4V5W_Rn6Ao8rM',
  b2b: {
    enabled: false,
    purchaseEnabled: false,
    storyblokBasePath: 'b2b',
    applicationId: 1636,
    algoliaIndex: 'b2c-at-de-DE-products',
    algoliaIndexAutocomplete: 'b2c-at-de-DE-products_query_suggestions',
    displayIncVat: false,
    default: false,
    productBasePath: 'b2b/produkt',
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-at.xml',
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1636,
    algoliaIndex: 'b2c-at-de-DE-products',
    algoliaIndexAutocomplete: 'b2c-at-de-DE-products_query_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'produkt',
    sitemapUrl: 'https://ecom-api.kahrs.com/storage/sitemaps/sitemap-at-b2c.xml',
  },
  features: {
    fastOrder: false,
    backorders: false,
    cartSettings: true,
    onlyAllowCustomerEditAddressesForSamples: true,
    disableShipToConsumer: false,
  },
  showNonPublicProducts: false,
};

const at: DomainMapper[] = ['new.kahrs.com', 'www.kahrs.com'].map((domain) => ({
  ...base,
  domain,
  legacyDomain: domain === 'new.kahrs.com',
  url: `https://${domain}/${base.storyblokBasePath}`,
} as DomainMapper));

export default at;
